











import { Vue, Component } from "vue-property-decorator";

import { ResetPasswordForm } from "@/components/forms";
import { NotFoundPage } from "@/components/pages/NotFoundPage";
import { personalModule } from "@/plugins/store-accessors";

@Component({
  components: {
    Error: NotFoundPage,
    ResetPasswordForm,
  },
})
export default class ResetPassPage extends Vue {
  get getError() {
    return personalModule.getError;
  }

  get code() {
    return this.$route.params.token;
  }

  mounted() {
    this.getStatus();
  }

  async getStatus() {
    if (this.code) {
      await personalModule.getResetStatus(this.$route.path);
    }
  }
}
